import React, { useState, useEffect } from "react";
import {
  Collapse, Navbar, NavbarToggler, NavbarBrand, Nav,
  NavItem, NavLink, UncontrolledDropdown, DropdownToggle,
  DropdownMenu, DropdownItem
} from "reactstrap";
import axios from 'axios';
import { CircularProgress } from "@mui/material";
import layers from '../markerIcons/layers1.png';
import logout from '../markerIcons/logout.png';
import report from '../markerIcons/seo-report.png';
import skills from '../markerIcons/skills.png';
import search from '../markerIcons/search.png';
import mapIcon from '../markerIcons/map.png';
import './styles/navcss.css';

const NavBar = ({ showForm, createReport, showSearchForm, isAccountScreen, user, stillLoading, setFilterMarkersFromNavbar, canWrite = true, isReadOnly = false, roleName = '' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [toggleOpen, setToggleOpen] = useState(false);
  const [isDroppedDown, setIsDroppedDown] = useState(window.innerWidth > 768);
  const [markerFilters, setMarkerFilters] = useState(
    localStorage.getItem('markerFilters') ? localStorage.getItem('markerFilters').split(',') : []
  );

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!document.getElementById('clickBox').contains(e.target)) {
        setIsOpen(false);
      }
    };

    const handleResize = () => {
      setIsOpen(false);
      setIsDroppedDown(window.innerWidth > 768);
    };

    window.addEventListener('click', handleClickOutside);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('click', handleClickOutside);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const toggle = () => setIsOpen(!isOpen);

  const toggleMenu = () => setToggleOpen(!toggleOpen);

  const signOut = async () => {
    try {
      await axios.get('/logout');
      window.location = "/login";
    } catch (error) {
      console.error('Logout failed', error);
    }
  };

  const filterMarker = (item) => {
    const updatedFilters = markerFilters.includes(item)
      ? markerFilters.filter(x => x !== item)
      : [...markerFilters, item];
    
    setMarkerFilters(updatedFilters);
    localStorage.setItem('markerFilters', updatedFilters.toString());

    // Persist layer preferences via server (Firebase Admin) so they survive across logins.
    if (user?.sub) {
      axios.put('/api/user/layer-preferences', {
        layerPreferences: updatedFilters.toString(),
      }).catch(err => console.warn('Could not save layer preferences:', err));
    }

    window.dispatchEvent(new Event("storage"));
    setFilterMarkersFromNavbar();
  };

  const renderServiceCheckbox = (id, icon, label, className = "") => (
    <div className="dropDownCheck">
      <img src={require(`../markerIcons/${icon}.svg`)} 
           className={className} 
           style={{ width: '20px', height: '20px' }} />
      <span style={id === 'TrafficSign' ? {padding: '0px 1px'} : 
                   id === 'WaterMeter' ? {fontSize: "13px", paddingTop: "1px"} : {}}>
        {label}
      </span>
      <label className="checkContainer">
        <input 
          type="checkbox" 
          checked={markerFilters.includes(id)} 
          onChange={() => filterMarker(id)} 
        />
        <span className="checkmark checkBrown"></span>
      </label>
    </div>
  );

  return (
    <div className="google-map-container" style={{ zIndex: "3000", position: "absolute", width: "100%" }}>
      <Navbar color="dark" dark expand="md" id='clickBox' style={isDroppedDown ? { minHeight: '73.6px' } : {}}>
        <NavbarBrand href="/">
          <h1 style={{ margin: "auto", fontSize: "1.4rem" }}><b>Main Street Assets</b></h1>
        </NavbarBrand>
        <NavbarToggler onClick={toggle} />
        
        {!isAccountScreen && (
          <span 
            style={{ 
              color: "white", 
              fontSize: "12px", 
              cursor: "pointer", 
              ...(isDroppedDown 
                ? { position: "absolute", left: "50%", transform: "translateX(-50%)" } 
                : { minWidth: '200px' })
            }}
          >
            Organization: {user.ClientName}
          </span>
        )}
        
        <Collapse isOpen={isOpen} navbar>
          <Nav className="ml-auto" navbar>
            {!isAccountScreen && (
              <div style={isDroppedDown ?
                { display: "flex", flexDirection: "row", alignItems: "center" }
                : { display: "flex", flexDirection: "column", alignItems: "center" }}>
                {canWrite && showForm && (
                  <NavItem>
                    <NavLink href="#" onClick={showForm} className='mainNavItem'>
                      {isDroppedDown ? (
                        <div className="tooltipNav">
                          <i className="fa fa-plus" aria-hidden="true"></i>
                          <span className="tooltipNavtext">Add Asset</span>
                        </div>
                      ) : (
                        <span style={{ color: "white" }}>Add Asset</span>
                      )}
                    </NavLink>
                  </NavItem>
                )}
                
                <NavItem>
                  {stillLoading ? (
                    <NavLink href="#" className='mainNavItem'>
                      <div style={{ width: '25px', height: '25px' }}>
                        <CircularProgress size={25}/>
                      </div>
                    </NavLink>
                  ) : (
                    <NavLink href="#" onClick={showSearchForm} className='mainNavItem'>
                      {isDroppedDown ? (
                        <div className="tooltipNav">
                          <img src={search} alt="search" style={{ width: '25px', height: '25px' }} />
                          <span className="tooltipNavtext">Search / Create a work list</span>
                        </div>
                      ) : (
                        <span style={{ color: "white" }}>Search</span>
                      )}
                    </NavLink>
                  )}
                </NavItem>
                
                <NavItem>
                  <NavLink href="#" onClick={createReport} className='mainNavItem'>
                    {isDroppedDown ? (
                      <div className="tooltipNavReports">
                        <img src={report} alt="reports" style={{ width: '25px', height: '25px' }} />
                        <span className="tooltipNavReportstext">Reports</span>
                      </div>
                    ) : (
                      <span style={{ color: "white" }}>Reports</span>
                    )}
                  </NavLink>
                </NavItem>
                
                <UncontrolledDropdown nav inNavbar toggle={toggleMenu} isOpen={toggleOpen} className='mainNavDropdownLink'>
                  <DropdownToggle nav>
                    {isDroppedDown ? (
                      <div className="tooltipNavLayers">
                        <img src={layers} alt="Layers" style={{ width: '25px', height: '25px' }} />
                        <span className="tooltipNavLayerstext">Services</span>
                      </div>
                    ) : (
                      <div style={{ display: "flex", justifyContent: "center" }}>Services</div>
                    )}
                  </DropdownToggle>
                  
                  <DropdownMenu end style={isDroppedDown ? { left: "-40px" } : { left: "40px" }}>
                    {renderServiceCheckbox('Hydrant', 'hydrant', 'Hydrants')}
                    {renderServiceCheckbox('Manhole', 'manhole', 'Manholes', 'leaflet-svg-icon-sewer')}
                    {renderServiceCheckbox('Valve', 'valve', 'Valves')}
                    {renderServiceCheckbox('TrafficSign', 'trafficSign', 'Traffic Signs')}
                    {renderServiceCheckbox('WaterLine', 'waterline', 'Water Lines')}
                    {renderServiceCheckbox('SewerLine', 'sewerline', 'Sewer Lines')}
                    {renderServiceCheckbox('WaterMeter', 'watermeter', 'Water Meters')}
                    
                    <DropdownItem divider />
                    <DropdownItem onClick={() => window.open('https://mainstreetassets.us/pages/contact', '_blank')}>
                      Contact Us
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
                
                <NavLink href="/account" className='mainNavItem'>
                  {isDroppedDown ? (
                    <div className="tooltipNavSettings">
                      <img src={skills} alt="skills" style={{ width: '25px', height: '25px' }} />
                      <span className="tooltipNavSettingstext">Account</span>
                    </div>
                  ) : (
                    <span style={{ color: "white" }}>Account</span>
                  )}
                </NavLink>

                <NavItem>
                  <NavLink href="/calls" className='mainNavItem'>
                    {isDroppedDown ? (
                      <div className="tooltipNav">
                        <i className="fa fa-phone" aria-hidden="true"></i>
                        <span className="tooltipNavtext">Calls</span>
                      </div>
                    ) : (
                      <span style={{ color: "white" }}>Calls</span>
                    )}
                  </NavLink>
                </NavItem>
              </div>
            )}
            
            {isAccountScreen && (
              <NavLink href="/" className='mainNavItem'>
                {isDroppedDown ? (
                  <div className="tooltipNavSettings">
                    <img src={mapIcon} alt="map" style={{ width: '25px', height: '25px' }} />
                    <span className="tooltipNavSettingstext">Map</span>
                  </div>
                ) : (
                  <span style={{ color: "white" }}>Map</span>
                )}
              </NavLink>
            )}
            
            <NavLink href="#" onClick={signOut} className='mainNavItem'>
              {isDroppedDown ? (
                <div className="tooltipNavLogout">
                  <img src={logout} alt="logout" style={{ width: '25px', height: '25px' }} />
                  <span className="tooltipNavLogouttext">Sign Out</span>
                </div>
              ) : (
                <span style={{ color: "white" }}>Sign Out</span>
              )}
            </NavLink>
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
};

export default NavBar;
